import { DEFAULT_AVATAR } from "@constants";
import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  avatarUrl: Yup.string().nullable(),
  headLine: Yup.string().nullable(),
  facebookLink: Yup.string().nullable(),
  linkedlnLink: Yup.string().nullable(),
  youtubeLink: Yup.string().nullable(),
  fullName: Yup.string().nullable().required("Full Name is required"),
  description: Yup.string()
    .nullable()
    .required("You need to write some descriptions about yourself")
    .max(500, "Your biography should not have more than 500 characters."),
});

export const initialValues = {
  avatarUrl: DEFAULT_AVATAR,
  fullName: "",
  headLine: "",
  description: "",
  facebookLink: "",
  linkedlnLink: "",
  youtubeLink: "",
};
